import { useInstance, createRef } from 'intact-vue';
import { useState } from '../../hooks/useState';
export var PanelTypes;
(function (PanelTypes) {
  PanelTypes[PanelTypes["Date"] = 0] = "Date";
  PanelTypes[PanelTypes["Time"] = 1] = "Time";
})(PanelTypes || (PanelTypes = {}));
export var PanelFlags;
(function (PanelFlags) {
  PanelFlags[PanelFlags["Start"] = 0] = "Start";
  PanelFlags[PanelFlags["End"] = 1] = "End";
})(PanelFlags || (PanelFlags = {}));
export function usePanel(type) {
  if (type === void 0) {
    type = PanelTypes.Date;
  }
  var instance = useInstance();
  var startPanel = useState(type);
  var endPanel = useState(type);
  var startRef = createRef();
  var endRef = createRef();
  function changePanel(type, flag) {
    if (flag === void 0) {
      flag = PanelFlags.Start;
    }
    getPanel(flag).set(type);
  }
  function getPanel(flag) {
    return flag === PanelFlags.Start ? startPanel : endPanel;
  }
  function reset() {
    startPanel.set(type);
    endPanel.set(type);
  }
  instance.on('show', reset);
  return {
    startPanel: startPanel,
    endPanel: endPanel,
    changePanel: changePanel,
    getPanel: getPanel,
    reset: reset,
    startRef: startRef,
    endRef: endRef
  };
}